import React from 'react';
import styled, {css} from "styled-components";


export const StyledSection = styled.div`
  ${({$noBottomMargin}) => !$noBottomMargin && css`
    &:not(last-child) {
      margin-bottom: 1rem;
    }
  `}
  & > .ui.header {
    text-transform: uppercase;
    color: #475566;
    font-size: 1.4285714285714286rem;
    font-weight: 400;
  }
`;


export const StyledTitle = styled.div`
  border: 1px solid #C4D6E9 !important;
  //border-radius: 0.5714285714285714rem;
  align-items: center !important;
  background: #F5F7FB !important;
  border-bottom: 0 !important; //1px solid #C4D6E9;
  border-top-left-radius: 0.5714285714285714rem;
  border-top-right-radius: 0.5714285714285714rem;
  display: inline-flex;
  margin: 0 !important;
  //padding: 1rem !important;
  width: 100%;
  padding-left: 18px;
  padding-right: 18px;


  & > h2 {
    color: #475566;
    font-size: 1.4285714285714286rem;
    font-weight: normal;
    line-height: 1.4285714285714286rem;
    margin: 0 0.6428571428571429rem;
    text-transform: uppercase;
  }
`;

export const StyledFooter = styled.div`
  background: #F5F7FB !important;
  border: 1px solid #C4D6E9 !important;
  border-top: 0 !important;
  border-radius: 0 0 0.5714285714285714rem 0.5714285714285714rem !important;
  padding: 18px;

  ${({$borderRadiusTop}) => $borderRadiusTop && css`
    & {
      border-top: 1px solid #C4D6E9 !important;
      border-top-left-radius: 0.5714285714285714rem !important;
      border-top-right-radius: 0.5714285714285714rem !important;
      padding: 14px;
    }
  `}
`

export const StyledContent = styled.div`
  ${({$borderRadiusTop}) => !$borderRadiusTop && css`
    & {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  `}
  ${({$borderRadiusBottom}) => !$borderRadiusBottom && css`
    & {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  `}
  border-radius: 0.5714285714285714rem;
  border: 1px solid #C4D6E9;
  background: #E7EFF6 !important;
  padding: 18px;
  
  input {
    min-height: 37px;
  }
  ${({$padding0}) => $padding0 && css`
    & {
      padding: 0;
    }
  `}
`;

const Section = ({children, titleContent, footerContent, padding0 = false}) => {
    return (
        <StyledSection>
            {titleContent && <StyledTitle>
                {titleContent}
            </StyledTitle>}
            {children && <StyledContent $padding0={padding0} $borderRadiusTop={!titleContent} $borderRadiusBottom={!footerContent}>
                {children}
            </StyledContent>}
            {footerContent && <StyledFooter $borderRadiusTop={!children}>
                {footerContent}
            </StyledFooter>}
        </StyledSection>
    );
};

export default Section;


// WEBPACK FOOTER //
// ./App/components/Section.jsx